<template>
    <div class="text-sm leading-tight text-gray-600">
        <div :key="index" v-for="(item,index) in missionProfileSummary" class="inline">
            <span :class="isFitting ? null : item.class">{{item.text}}</span>
            <span v-if="index < missionProfileSummary.length - 1"> - </span>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "MissionProfileSummary",
        props: ['missionProfile', 'isFitting'],
        computed: {
            ...mapState('mission', {
                'filter': 'filter'
            }),
            missionProfileSummary() {
                let profileItems = [];
                let patientGenders = [];
                let profileAlertClass = 'profile-alert';

                // Number of Patientes
                let patientClass = '';

                if ((this.filter.one_patient && !this.filter.two_patients)
                    || (!this.filter.one_patient && this.filter.two_patients)) {
                    if (this.filter.one_patient && this.missionProfile.number_of_patients === 2) {
                        patientClass = profileAlertClass;
                    } else if (this.filter.two_patients && this.missionProfile.number_of_patients === 1) {
                        patientClass = profileAlertClass;
                    }
                }

                profileItems.push({
                    text: `${this.missionProfile.number_of_patients} ${this.$tc('text.patient', this.missionProfile.number_of_patients)}`,
                    class: patientClass
                });

                // Night Work
                let nightCommitmentSelected = false;
                if (this.filter.night_commitment_none || this.filter.night_commitment_once || this.filter.night_commitment_multiple) {
                    nightCommitmentSelected = true;
                }
                if (this.missionProfile.night_work === null) {
                    profileItems.push(`${this.$t('text.unknown')}`);
                } else if (this.missionProfile.night_work === 0) {
                    profileItems.push({
                        text: `${this.$t('text.night_work_0')}`,
                        class: nightCommitmentSelected && !this.filter.night_commitment_none ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.night_work === 1) {
                    profileItems.push({
                        text: `${this.$t('text.night_work_1')}`,
                        class: nightCommitmentSelected && !this.filter.night_commitment_once ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.night_work === 2) {
                    profileItems.push({
                        text: `${this.$t('text.night_work_2')}`,
                        class: nightCommitmentSelected && !this.filter.night_commitment_multiple ? profileAlertClass : ''
                    });
                }

                let dementiaSelected = false;
                if (this.filter.dementia_no || this.filter.dementia_yes) {
                    dementiaSelected = true;
                }

                // Dementia
                if (this.missionProfile.dementia) {
                    profileItems.push({
                        text: `${this.$t('text.dementia')}`,
                        class: dementiaSelected && this.filter.dementia_no && !this.filter.dementia_yes ? profileAlertClass : ''
                    });
                }

                // Family members present
                if (this.missionProfile.family_members_present) {
                    profileItems.push({
                        text: `${this.$t('text.family_members_present')}`,
                        class: !this.filter.further_persons_household ? profileAlertClass : ''
                    });
                }

                // Patient gender's
                if (this.missionProfile.female_patients) {
                    patientGenders.push(`${this.$t('text.female_patients')}`);
                }

                if (this.missionProfile.male_patients) {
                    patientGenders.push(`${this.$t('text.male_patients')}`);
                }

                let genderMismatch = false;
                if (this.filter.gender_option === 1 && this.missionProfile.male_patients) {
                    genderMismatch = true;
                }
                if (this.filter.gender_option === 0 && this.missionProfile.female_patients) {
                    genderMismatch = true;
                }

                if (patientGenders.length > 0) {
                    profileItems.push({
                        text: patientGenders.join(', '),
                        class: genderMismatch ? profileAlertClass : ''
                    });
                }

                let patientMobilitySelected = false;
                if (this.filter.patients_fully_mobile
                    || this.filter.patients_wheelchair
                    || this.filter.patients_bedridden) {
                    patientMobilitySelected = true;
                }

                // Patient Mobility
                if (this.missionProfile.patient_mobility === 1) {
                    profileItems.push({
                        text: `${this.$t('text.patient_mobility_1')}`,
                        class: patientMobilitySelected && !this.filter.patients_fully_mobile ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.patient_mobility === 2) {
                    profileItems.push({
                        text: `${this.$t('text.patient_mobility_2')}`,
                        class: patientMobilitySelected && !this.filter.patients_fully_mobile ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.patient_mobility === 3) {
                    profileItems.push({
                        text: `${this.$t('text.patient_mobility_3')}`,
                        class: patientMobilitySelected && !this.filter.patients_fully_mobile ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.patient_mobility === 4) {
                    profileItems.push({
                        text: `${this.$t('text.patient_mobility_4')}`,
                        class: patientMobilitySelected && !this.filter.patients_wheelchair ? profileAlertClass : ''
                    });
                } else if (this.missionProfile.patient_mobility === 5) {
                    profileItems.push({
                        text: `${this.$t('text.patient_mobility_5')}`,
                        class: patientMobilitySelected && !this.filter.patients_bedridden ? profileAlertClass : ''
                    });
                }

                return profileItems;
            },
        },
    }
</script>

<style>
    .profile-alert {
        color: darkmagenta;
        font-weight: bold;
    }
</style>